import React from "react";
import Table from '../base_table';
import type { TableRef } from '../base_table';
import type { ColumnDef } from "@tanstack/react-table";
import { FilingPackEvent } from "../../shared/Types";
import { TableSpinner, TableMessage, TableError } from '../base_table/table-components/TableStates';

interface EventsTableProps {
    tableRef: React.Ref<TableRef>;
    columns?: () => ColumnDef<FilingPackEvent, any>[];
    data: FilingPackEvent[];
    isLoading: boolean;
    error: any;
}

export const EventsTable = React.memo(
    function EventsTable({
        tableRef,
        columns,
        data,
        isLoading,
        error,
    }: EventsTableProps) {
        
        if (error) return (
            <TableError message={error.message || String(error)} />
        );

        return (
            <div style={{ height: "100%" }}>
                <Table
                    className="events-table"
                    isNested
                    ref={tableRef}
                    columns={columns ? (columns() as any) : []}
                    data={data}
                    noDataContent={isLoading ? <TableSpinner /> : <TableMessage msg="No Events Found" />}
                    noDataText={isLoading ? "Loading events..." : "No events found."}
                />
            </div>
        );
    }
);
